import React from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Coupons from "./components/Pages/Coupons/Coupons";
import Campaigns from "./components/Pages/Campaigns/Campaigns";
import Agreements from "./components/Pages/Agreements/Agreements";
import Contact from "./components/Pages/Contact/Contact";
import Help from "./components/Pages/Help/Help";
import Settings from "./components/Pages/Settings/Settings";
import Login from "./components/Pages/Login/Login";
import Collections from "./components/Pages/Collections/Collections";
import CreditPackage from "./components/Pages/CreditPackage/CreditPackage";
import StoragePlan from "./components/Pages/Storage/Storage";
import Extensions from "./components/Pages/Extensions/Extensions";
import AIStudioManager from "./components/Pages/AIStudioManager/AIStudioManager";
import PlanControl from "./components/Pages/PlanControl/PlanControl";
import StripeProvisioningFailures from "./components/Pages/StripeProvisioningFailures/StripeProvisioningFailures";
import ProtectedRoute from "./components/Layout/ProtectedRoute";

const PageRouter = (data) => {
  return (
    <Router>
      <Switch>
        {/* Rutas públicas (sin layout) */}
        <Route
          exact
          path="/"
          render={(props) => <Login {...data} {...props} />}
        />
        <Route
          path="/login"
          render={(props) => <Login {...data} {...props} />}
        />
        
        {/* Rutas protegidas (con AdminLayout) */}
        <ProtectedRoute
          path="/coupons"
          render={(props) => <Coupons {...data} {...props} />}
        />
        <ProtectedRoute
          path="/campaigns"
          render={(props) => <Campaigns {...data} {...props} />}
        />
        <ProtectedRoute
          path="/agreements"
          render={(props) => <Agreements {...data} {...props} />}
        />
        <ProtectedRoute
          path="/contact"
          render={(props) => <Contact {...data} {...props} />}
        />
        <ProtectedRoute
          path="/help"
          render={(props) => <Help {...data} {...props} />}
        />
        <ProtectedRoute
          path="/settings"
          render={(props) => <Settings {...data} {...props} />}
        />
        <ProtectedRoute
          path="/collections"
          render={(props) => <Collections {...data} {...props} />}
        />
        <ProtectedRoute
          path="/credit-package"
          render={(props) => <CreditPackage {...data} {...props} />}
        />
        <ProtectedRoute
          path="/storage"
          render={(props) => <StoragePlan {...data} {...props} />}
        />
        <ProtectedRoute
          path="/extensions"
          render={(props) => <Extensions {...data} {...props} />}
        />
        <ProtectedRoute
          path="/ai-studio"
          render={(props) => <AIStudioManager {...data} {...props} />}
        />
        <ProtectedRoute
          path="/PlanControl"
          render={(props) => <PlanControl {...data} {...props} />}
        />
        <ProtectedRoute
          path="/stripe-provisioning-failures"
          render={(props) => <StripeProvisioningFailures {...data} {...props} />}
        />
      </Switch>
    </Router>
  );
};

export default PageRouter;
